import * as Sentry from '@sentry/react';

import { Error } from '../../../shared/components/UI/Error/Error';

import { useSidepanel } from '../../../shared/contexts/Sidepanel.provider';
import type { TengoDocument } from '../../../shared/entities/TengoDocument';
import { DocumentSidePanel } from '../components/DocumentSidePanel';

export function useDocumentSidePanel<T extends TengoDocument>({
  documents,
  noBackdrop = false,
}: {
  documents: T[];
  noBackdrop?: boolean;
}) {
  const { togglePanel, closePanel } = useSidepanel();

  const openPanel = (selectedDocument: T) => {
    togglePanel({
      noBackdrop,
      content: (
        <Sentry.ErrorBoundary fallback={<Error />}>
          <DocumentSidePanel
            documents={documents}
            closePanel={closePanel}
            selectedDocument={selectedDocument}
          />
        </Sentry.ErrorBoundary>
      ),
    });
  };

  return { openPanel, closePanel };
}
